import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useI18n } from 'i18n/util'

const Container = styled.div`
  font-size: 14px;
  line-height: 16px;
  width: 100%;
`
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`
const LeftContainer = styled.div`
  color: #474d57;
  margin-right: 24px;
`

const RightCotainer = styled.div`
  color: #1e2026;
`

export const View = () => {
  const {
    delegatorAddress,
    validatorName,
    amount,
    validatorSrcAddress,
    validatorDstAddress,
    status,
    validatorDstName,
  } = useSelector(state => state.staking)
  const { formatI18nText } = useI18n()

  return (
    <Container>
      <Row>
        <LeftContainer>{formatI18nText('staking.notification.delegator.address')}</LeftContainer>
        <RightCotainer>{delegatorAddress}</RightCotainer>
      </Row>
      <Row>
        <LeftContainer>{formatI18nText('staking.notification.validator')}</LeftContainer>
        <RightCotainer>{validatorName}</RightCotainer>
      </Row>
      {status === 'redelegate' && (
        <>
          <Row>
            <LeftContainer>
              {formatI18nText('staking.notification.srcValidator.address')}
            </LeftContainer>
            <RightCotainer>{`${validatorName}(${validatorSrcAddress})`}</RightCotainer>
          </Row>
          <Row>
            <LeftContainer>
              {formatI18nText('staking.notification.dstalidator.address')}
            </LeftContainer>
            <RightCotainer>{`${validatorDstName}(${validatorDstAddress})`}</RightCotainer>
          </Row>
        </>
      )}

      <Row>
        <LeftContainer>{formatI18nText('staking.notification.amount')}</LeftContainer>
        <RightCotainer>{`${amount}BNB`}</RightCotainer>
      </Row>
      <Row>
        <LeftContainer>{formatI18nText('staking.notification.network.fee')}</LeftContainer>
        <RightCotainer>0.001</RightCotainer>
      </Row>
      <Row>
        <LeftContainer>{formatI18nText('staking.notification.total')}</LeftContainer>
        <RightCotainer>{`${amount + 0.001}BNB`}</RightCotainer>
      </Row>
    </Container>
  )
}

View.propTypes = {
  data: PropTypes.object,
}

View.defaultProps = {
  data: {},
}
